import { Toggle } from 'msteams-ui-components-react/lib/toggles';
import { Colors } from 'msteams-ui-styles-core';
import React from 'react';

export interface LabeledToggleProps {
  onToggle: (toggled: boolean) => any;
  checked: boolean;
  labelText: string;
  labelStyles?: LabeledToggleStyles;
  disabled?: boolean;
}

export interface LabeledToggleStyles {
  label?: React.CSSProperties;
  span?: React.CSSProperties;
  toggle?: React.CSSProperties;
}

export const LabeledToggle = ({
  onToggle,
  checked,
  labelText,
  labelStyles,
  disabled,
}: LabeledToggleProps) => {
  const defaultLabelStyles: React.CSSProperties = {
    display: 'flex',
    alignSelf: 'start',
    alignItems: 'center',
    cursor: 'pointer',
    overflow: 'hidden',
    width: 'fit-content',
  };

  const defaultSpanStyles: React.CSSProperties = {
    float: 'right',
    color: checked ? Colors.light.brand00 : Colors.light.gray01,
  };

  const defaultToggleStyles: React.CSSProperties = {
    top: -6,
    display: 'block',
    marginRight: '6px',
    backgroundColor: checked ? Colors.light.brand00 : Colors.light.gray10,
  };

  if (disabled) {
    defaultLabelStyles.cursor = 'default';
    defaultLabelStyles.opacity = '0.75';
    defaultToggleStyles.cursor = 'default';
  }

  function toggleClick(): void {
    if (!disabled) {
      onToggle(!checked);
    }
  }

  return (
    <label
      htmlFor='labeledToggle'
      style={{ ...defaultLabelStyles, ...labelStyles?.label }}
      onClick={toggleClick}
    >
      <span
        style={{
          ...defaultSpanStyles,
          ...labelStyles?.span,
        }}
      >
        {labelText}
      </span>
      <Toggle
        name='labeledToggle'
        checked={checked}
        style={{ ...defaultToggleStyles, ...labelStyles?.toggle }}
        onToggle={() => {
          // Handled by label
        }}
      />
    </label>
  );
};
